import React from 'react';
import moment from 'moment';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { regionDateAndTime } from 'utils';

const ReactstrapFormikDatePicker = ({
    field: { ...fields },
    form: { touched, errors, setFieldValue, setFieldTouched },
    ...props
}) => {
    const { id, ...rest } = props;
    return (
        <Form.Group controlId={id} className="form-group">
            {props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <Form.Control
                as={DatePicker}
                {...rest}
                {...fields}
                selected={(fields.value && new Date(fields.value)) || null}
                value={fields.value !== null && moment(fields.value).format(regionDateAndTime()?.GENERAL_DATE_FORMAT)}
                onChange={(e) => {
                    setFieldTouched(fields.name, true);
                    setFieldValue(fields.name, e);
                }}
                isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                popperClassName={fields.value ? '' : 'highlight-today'}
            />
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};
export default ReactstrapFormikDatePicker;
